export enum ApplicationType {
    Loan = 0,
    Leasing = 2,
    Personnel = 3,
}
